import { useState, useEffect } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getProductPermissions } from '@user/store/roles/api'
import { Product } from '@user/store/roles/typings'

export const useGetProductPermissionsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )
  const [products, setProducts] = useState<Product[]>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getProductPermissions())
        if (mounted) {
          if (getProductPermissions.fulfilled.match(result)) {
            unwrapResult(result)
            setProducts(result.payload)
            setStatus('success')
          } else {
            setProducts(undefined)
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setProducts(undefined)
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { status, products }
}
